const ENV = process.env.REACT_APP_ENV ?? "dev";

const DEV_ENDPOINT = process.env.REACT_APP_ENDPOINT || "https://api-dev.zenvoya.ai";
const PROD_ENDPOINT = process.env.REACT_APP_PROD_ENDPOINT || DEV_ENDPOINT;

const DEV_API_KEY = process.env.REACT_APP_API_KEY || "";
const PROD_API_KEY = process.env.REACT_APP_COMMON_PROD_API_KEY || "";

let ENDPOINT = "";
let API_KEY = "";
switch (ENV) {
  case "prod":
    ENDPOINT = PROD_ENDPOINT;
    API_KEY = PROD_API_KEY;
    break;
  case "dev":
    ENDPOINT = DEV_ENDPOINT;
    API_KEY = DEV_API_KEY;
    break;
  case "local":
  default:
    ENDPOINT = DEV_ENDPOINT;
    API_KEY = DEV_API_KEY;
    break;
}

const recommendedTripsURL = process.env.REACT_APP_RECOMMENDED_TRIPS_URL || "";
const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY || "";
const APP_URL = process.env.REACT_APP_APP_URL || "";
const environment = ENV;

// API gateway base path for backend-admin services. Auth endpoints
// (/app/v1/auth/...) stay on the legacy prefix and do not use this.
const BE_ADMIN_BASE = "/app/v1/beadmin";

export {
  ENDPOINT,
  recommendedTripsURL,
  ENCRYPTION_KEY,
  environment,
  APP_URL,
  API_KEY,
  BE_ADMIN_BASE,
};
